module.exports = __webpack_public_path__ + "img/full0-min.9d3ef8fe.png";